module.exports = __webpack_public_path__ + "static/media/btn_android_deu.a6a9ea3b.png";